import Vue from 'vue'
import VueI18n from 'vue-i18n'

import globalLocale from '@/lang/global.json'

Vue.use(VueI18n)

VueI18n.prototype.getChoiceIndex = function (choice) {
  if (choice <= 4 || choice >= 20) {
    if (choice % 10 < 4) return (choice % 10) % 4
  }
  return 4
}

export const i18n = new VueI18n({
  locale: 'zh-Hant',
  fallbackLocale: 'zh-Hant',
  messages: globalLocale,
  silentFallbackWarn: true,
})
